import ContentWrapper from "@/components/Core/ContentWrapper";
import NextLazyImage from "@/components/Core/NextLazyImage";
import mq from "@/utils/mq";
import styled, { css } from "styled-components";

const LargeQuoteWrapper = styled.div`
  width: 100%;
  max-width: 1136px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 46px;
  padding: 46px 0;
  ${mq.mobile(css`
    gap: 16px;
  `)};
`;

const Quote = styled.p`
  color: #f7f8f8;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: var(--font-pp-neue);
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 46px;
  ${mq.mobile(css`
    font-size: 24px;
    line-height: 34px;
  `)};
`;

const QuoteeInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  ${mq.mobile(css`
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `)};
`;

const LogoContainer = styled.div`
  height: 24px;
  width: fit-content;
  img {
    filter: invert(1) opacity(0.5);
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  ${mq.mobile(css`
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `)};
`;

const QuoteeRole = styled.p`
  color: #fff;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: var(--font-inter);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  ${mq.mobile(css`
    font-size: 16px;
    line-height: 16px;
  `)};
`;

const QuoteeName = styled.p`
  color: #7c7c7c;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: var(--font-inter);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  margin: 0;
  ${mq.mobile(css`
    font-size: 13px;
    line-height: 13px;
  `)};
`;

export default function LargeQuote({ quote, quoteeRole, quoteeName, logo }) {
  return (
    <ContentWrapper transparent>
      <LargeQuoteWrapper>
        <Quote>{quote}</Quote>
        <QuoteeInfo>
          <LogoContainer>
            <NextLazyImage src={logo.filename} alt={logo.alt} style={{ objectFit: "contain", width: "auto" }} />
          </LogoContainer>
          <TextWrapper>
            <QuoteeRole>{quoteeRole}</QuoteeRole>
            <QuoteeName>{quoteeName}</QuoteeName>
          </TextWrapper>
        </QuoteeInfo>
      </LargeQuoteWrapper>
    </ContentWrapper>
  );
}
